module.exports = __webpack_public_path__ + "static/img/67066G_1_C_20230613_fit.891aaca.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/67066G_1_C_20230613_fit.png
// module id = jR5N
// module chunks = 0